import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const FormGroup = ({ id, label, type, placeholder, value, onChange, error }) => {
  return (
    <div className="mb-6">
      <label htmlFor={id} className="block text-sm font-medium text-black mb-2">
        {label}
      </label>
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-2 border rounded-lg shadow-md focus:outline-none ${
          error ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
        }`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

const Login = ({setIsLogin}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate()
  const validate = () => {
    let newErrors = {};

    // Email validation
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "Invalid email format.";
    }

    // Password validation (At least 8 characters, one uppercase, one lowercase, one special char, one number)
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!password) {
      newErrors.password = "Password is required.";
    } else if (!passwordRegex.test(password)) {
      newErrors.password =
        "Password must be at least 8 characters and include 1 uppercase, 1 lowercase, 1 number, and 1 special character.";
    }
    console.log(newErrors, "newErrors")
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/adminlogin`, {
        email,
        password,
      });
      localStorage.setItem("token", response?.data?.token)
      localStorage.setItem("userData", JSON.stringify(response?.data?.user))
      setIsLogin(true)
      navigate("/")
    } catch (error) {
      console.error("Login Failed:", error.response?.data || error.message);
    }
  };

  useEffect(()=>{
    if(localStorage.getItem('token')){
      navigate('/')
    }
  },[])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-orange-50 to-white px-4 md:px-0">
      <div className="hidden lg:flex flex-col items-center justify-center w-1/2">
        <img src="images/logo.png" alt="logo" className="w-3/4 max-w-xs" />
        <p className="mt-4 text-gray-700 text-lg font-semibold text-center">
          Welcome to our platform! Please log in to continue.
        </p>
      </div>

      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-xl">
        <h2 className="text-3xl font-bold text-center text-black mb-8">Login</h2>
        <form onSubmit={onSubmit}>
          <FormGroup
            type="email"
            placeholder="abc@gmail.com"
            label="Email Address"
            id="email"
            value={email}
            onChange={(e) => {
              setErrors(prev => {
                return {...prev, email: ""}
              })
              setEmail(e.target.value)}}
            error={errors.email}
          />
          <FormGroup
            type="password"
            placeholder="Password"
            label="Password"
            id="password"
            value={password}
            onChange={(e) => {
              setErrors(prev => {
                return {...prev, password: ""}
              })
              setPassword(e.target.value)}}
            error={errors.password}
          />
          <button
            type="submit"
            className="w-full bg-orange hover:bg-blue-600 text-white py-3 px-4 rounded-lg font-bold shadow-md transition-transform transform hover:scale-105"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
